global.modules.set({
  async init(context) {
    $('[data-toggle="datepicker"]', context).each(function () {
      $(this).datepicker({
        language: 'en-GB',
        format: 'mm/dd/yyyy',
        startDate: '01/01/1000',
        endDate: '31/12/9999',
      });
    })
  }
})